import { CardContainer } from "@/components/commons/CardContainer";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { TSubjectCreateForm } from "@/features/learning-content/types/learningContent";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useFormContext } from "react-hook-form";

type TWordProblemDataFormProps = {};

// Word and problem data form section for subject creation
export const WordProblemDataForm: FC<TWordProblemDataFormProps> = () => {
  const { control } = useFormContext<TSubjectCreateForm>();

  return (
    <CardContainer sx={{ borderRadius: "8px" }}>
      <Stack gap={3}>
        <Typography variant="sub16Bold" sx={{ fontSize: "20px", fontWeight: 700 }}>
          単語・問題データ
        </Typography>

        <FormField control={control} name="vocabularySpreadsheetUrl">
          <Input fullWidth placeholder="入力してください" />
        </FormField>

        <FormField control={control} name="problemSpreadsheetUrl">
          <Input fullWidth placeholder="入力してください" />
        </FormField>
      </Stack>
    </CardContainer>
  );
};
